export class LocationGroupModel {
    public locationGroupId: string;
    public organisationId: string;
    public locationAttributeCode: string;
    public locationGroupName: string;
    public sortSequence: number;
    public statusCode: string;
}